import $ from "jquery"

// ### trace ###
export const trace = (...str)=> {
  if ($('body').data('mode') == 'dev') {
    console.info(...str);
  }
}

// Scroll to Position
export const scrollToPos = (topPx, time = 800, callback = null)=> {
  let $page = $('html, body');
  $page.animate({ scrollTop: topPx }, time, ()=>{
    if($.isFunction(callback)){
      callback()
    }
  });  
}

// Scroll to $target
export const scrollTo = ($target, offset = 0, time = 800, callback = null)=> {
  if (!$target.length) {
    return false;
  }
  let topPx = $target.offset().top - offset;
  scrollToPos(topPx, time, callback);
}

// http://coveroverflow.com/a/11381730/989439
export const mobilecheck = ()=> {
  let check = false;
  (function(a){if(/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
}

const onCollapseShow = (e) => {
  
  const trigger = getCollapseTrigger(e.currentTarget.id)
  if (trigger && trigger.dataset.labelExpanded) {
    const span = trigger.querySelector("span")
    const target = span ? span : trigger
    target.innerHTML = trigger.dataset.labelExpanded
  }
}
const onCollapseHide = (e) => {
  const trigger = getCollapseTrigger(e.currentTarget.id)
  if (trigger && trigger.dataset.labelCollapsed) {
    const span = trigger.querySelector("span")
    const target = span ? span : trigger
    target.innerHTML = trigger.dataset.labelCollapsed
  }
}
const getCollapseTrigger = (id) => {
  let trigger
  if (id) {
    trigger = document.querySelector("a[href='#" + id + "']")
  }
  return trigger
}

export const initCollapseLabel = () => {
  $('body').on("show.bs.collapse", ".collapse", onCollapseShow)
  $('body').on("hide.bs.collapse", ".collapse", onCollapseHide)
}



export const UiHelpers = {


  // bootstrap collapse
  // toggle button label
  initCollapseButtonLabel() {

    /*
    $('body').on("shown.bs.collapse hidden.bs.collapse", ".collapse", (e)=> {
      let $collapse = $(e.target);
      let id = $collapse.attr("id");
      let $btn = $('a[href="#' + id + '"]');
      if ($btn.length) {
        let labelCollapsed = $btn.data("labelcollapsed");
        let labelExpanded = $btn.data("labelexpanded");
        if (labelCollapsed && labelExpanded) {
          if ($collapse.hasClass("in")) {
            $btn.html(labelExpanded);
          }
          else {
            $btn.html(labelCollapsed);
          }

        }
      }
    });
    */
  },

  // forn input autofocus
  initFormInputAutofocus() {
    $('input.autofocus').focus();
  },

  // init scroll to
  initScrollTo() {
    $('body').on('click', '.scroll-to', (e)=> {      
      let $btn = $(e.currentTarget);
      let selector = $btn.attr("href");
      if (selector) {
        let $target = $(selector);
        if ($target.length) {
          e.preventDefault();
          let offset = 130;
          if ($btn.data("offset")) {
            offset = $btn.data("offset");
          }
          scrollTo($target, offset);
        }
      }
    });
  },

  // scrollto collapse
  // scrolls page to a shown collapse element
  // unles class .no-scroll is added
  initScrollToCollapse() {
    $('body').on("shown.bs.collapse", ".collapse", (e)=> {
      let $t = $(e.target);
      if ($t.height() > 400) {
        scrollTo($t, 130);
      }
    });
  },

  init() {
    // collapse toggle btn label
    this.initCollapseButtonLabel();
    // init input.autofocus
    this.initFormInputAutofocus();
    // init scroll-to
    this.initScrollTo();
    // init scroll to collapse
    this.initScrollToCollapse();
  }

}
